import { gql } from "@apollo/client"

const UPDATE_GROUPS_LOCATION_MUTATION = gql`
  mutation($input: UpdateGroupsLocationInput!) {
    updateGroupsLocation(input: $input) {
      id
      title
      location {
        id
        name
      }
    }
  }
`

export { UPDATE_GROUPS_LOCATION_MUTATION }
